import React from 'react';
import './RowActions.scss';

const RowActions = ({children}) => {
  return <div className='row__actions'>{children}</div>;
};

export default RowActions;
